<!--
  A filterable version of ElSelect

  Props:
  - value: the input value
  - options: an array of availbale option objects
  - keyField: the field where to read the key (default valueField)
  - labelField: the field where to read the displayed name (default valueField)
  - valueField: the field where to read the value (default "value")
-->

<template>
  <el-select
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
    filterable
    :filter-method="filterMethod"
    @focus="handleFocus"
    >
    <slot :query="query" :options="filteredOptions">
      <el-option
        v-for="(item, index) in filteredOptions"
        :key="itemKey(item, index)"
        :value="itemValue(item)"
        :label="itemLabel(item)">
        <slot name="option" :item="item" :index="index">
          <span class="el-filterable-select__left">{{ item.left }}</span>
          <strong class="el-filterable-select__match">{{ item.match }}</strong>
          <span class="el-filterable-select__right">{{ item.right }}</span>
        </slot>
      </el-option>
    </slot>
  </el-select>
</template>

<script>
import { getValueByPath } from 'element-ui/src/utils/util'

import { filterSuggestions } from '../../utils/filter.js'

export default {
  name: 'ElFilterableSelect',

  props: {
    value: {},
    options: Array,

    keyField: {
      type: [String, Function],
      default: null,
    },
    valueField: {
      type: [String, Function],
      default: 'value',
    },
    labelField: {
      type: [String, Function],
      default: null,
    },
  },

  data () {
    return {
    // filteredOptions [],
      query: '',
    }
  },

  computed: {
    filteredOptions () {
      return filterSuggestions(this.query, this.options || [], this.itemLabel.bind(this))
    },
  },

  methods: {
    itemKey (item, index) {
      let keyField = this.keyField || this.valueField
      if (typeof keyField === 'function') return keyField(item, index)
      if (typeof item !== 'object') return item
      else if (keyField) return getValueByPath(item, keyField)
      else return index
    },
    itemValue (item) {
      if (typeof this.valueField === 'function') return this.valueField(item)
      if (!this.valueField || typeof item !== 'object') return item
      return getValueByPath(item, this.valueField)
    },
    itemLabel (item) {
      let labelField = this.labelField || this.valueField
      if (typeof labelField === 'function') return labelField(item)
      if (typeof item !== 'object') return item
      else if (labelField) return getValueByPath(item, labelField)
      else return ''
    },
    filterMethod (query) { this.query = query },
    handleFocus () { this.query = '' },
  },
}
</script>
